module.exports = __webpack_public_path__ + "img/strataggem_logo.fb2c4bef.svg";